
export default function FAQHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#F8F9FA] via-white to-[#F8F9FA] pt-32 pb-20 min-h-[70vh] flex items-center">
      {/* Immagine di sfondo */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/7da96c30952792d7b7a54af313719e6f.jpg"
          alt="Team professionale che risponde a domande"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F3B]/85 via-[#0B1F3B]/75 to-[#0B1F3B]/85"></div>
      </div>

      {/* Contenuto */}
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Domande Frequenti
        </h1>
        <p className="text-xl text-white/90 mb-8 leading-relaxed">
          Tutto quello che devi sapere sulla valorizzazione del tuo brand e su come trasformare il marketing in un patrimonio aziendale concreto
        </p>
        <a 
          href="/contatti" 
          className="inline-block bg-[#E879F9] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#E879F9]/90 transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
        >
          Hai altre domande? Contattaci
        </a>
      </div>
    </section>
  );
}
